<div class="fields fuel-line" [formGroup]="group()">
    <label class="field">
        <span class="label required">{{ "FLIGHT_LIST.fuel.name" | translate }}</span>
        <kendo-textbox [formControlName]="fields().name"></kendo-textbox>
        @if (group().hasError("fuelName")) {
            <span class="error">{{ "FLIGHT_LIST.edit.errors.fuelName" | translate }}</span>
        }
    </label>
    @for (quantity of quantities; track quantity.key) {
        <div class="field">
            <span class="label" [class.required]="quantity.key === 'arrival' || (quantity.key === 'refuel' && refuelRequired())">{{ quantity.title | translate }}</span>
            <div class="quantity">
                <!-- The total is worked out from the arrival fuel and the refuel, as in the app. -->
                <kendo-numerictextbox
                    [formControlName]="fields()[quantity.key]"
                    format="#.##"
                    [decimals]="2"
                    [min]="0"
                    [spinners]="false"
                    [readonly]="quantity.key === 'total'"
                ></kendo-numerictextbox>
                <kendo-dropdownlist [formControlName]="fields()[quantity.key] + 'Unit'" [data]="units()"></kendo-dropdownlist>
            </div>
            @if (quantity.key === "arrival" && group().hasError("fuelArrival")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.fuelArrival" | translate }}</span>
            }
            @if (quantity.key === "refuel" && group().hasError("refuel")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.refuel" | translate }}</span>
            }
        </div>
    }
    <label class="field">
        <span class="label">{{ "FLIGHT_LIST.refuelLocation" | translate }}</span>
        <kendo-textbox [formControlName]="fields().location"></kendo-textbox>
    </label>
    @if (group().hasError("atLeastOne")) {
        <span class="error row-error">{{ "FLIGHT_LIST.edit.errors.atLeastOne" | translate }}</span>
    }
    @if (group().hasError("maxTank")) {
        <span class="error row-error">{{ "FLIGHT_LIST.edit.errors.maxTank" | translate: { max: maxTankText() } }}</span>
    }
</div>
